function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".NavyLogo_svg__cls-1{fill:#082f4d}"));
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "NavyLogo_svg__Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "NavyLogo_svg__Layer_1-2",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("ellipse", {
  className: "NavyLogo_svg__cls-1",
  cx: 19.26,
  cy: 11.4,
  rx: 11.36,
  ry: 11.4
}), /*#__PURE__*/React.createElement("rect", {
  className: "NavyLogo_svg__cls-1",
  x: 0.83,
  y: 26.76,
  width: 36.3,
  height: 22.14,
  rx: 2.5
}), /*#__PURE__*/React.createElement("rect", {
  className: "NavyLogo_svg__cls-1",
  x: 0.83,
  y: 81.39,
  width: 36.3,
  height: 22.14,
  rx: 2.5,
  transform: "rotate(-5.26 18.985 92.5)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "NavyLogo_svg__cls-1",
  x: 0.83,
  y: 53.08,
  width: 36.3,
  height: 22.14,
  rx: 2.5,
  transform: "matrix(.99 .11 -.11 .99 6.97 -1.66)"
}), /*#__PURE__*/React.createElement("path", {
  className: "NavyLogo_svg__cls-1",
  d: "M93.46 58.77h-14.8v25.1c0 6.43.11 11.58 7.51 11.58a16.32 16.32 0 007.4-1.71l.32 7.61a25.39 25.39 0 01-9.76 1.82c-11.91 0-13.84-6.43-13.84-16.83V58.77H59.35v-7.08h10.94V37.43h8.37v14.26h14.8zM99.89 58.13c5.15-5.26 12.66-7.73 20-7.73 14.8 0 21 7.08 21 21.24V93.2a55.78 55.78 0 00.75 8.69h-8a35.7 35.7 0 01-.54-7.51h-.21a19 19 0 01-16.52 8.79c-10.19 0-18.66-5.14-18.66-14.9 0-16.63 19.3-17.59 31.64-17.59h3.22v-1.51c0-7.29-4.62-11-12.44-11a22.24 22.24 0 00-14.91 5.47zm24.24 19.63c-10.62 0-17.48 2.89-17.48 9.65 0 6.33 4.72 8.68 11 8.68 9.65 0 14.58-7 14.8-15.12v-3.21zM153 63.6c0-4.61-.43-8.58-.43-11.91h7.94c0 2.68.21 5.47.21 8.26h.22c2.25-4.93 8.47-9.55 16.73-9.55 13.19 0 19.09 8.37 19.09 20.49v31h-8.37V71.75c0-8.37-3.64-13.62-11.47-13.62-10.84 0-15.55 7.83-15.55 19.3v24.46H153zM251.11 93h-.21c-3.11 5.69-10.3 10.19-19.31 10.19-14.05 0-25.09-11.37-25.09-26.38 0-15.23 10.61-26.39 26.38-26.39a23.26 23.26 0 0118 8.59h.21V20.8h8.37v81.09h-8.37zm-17.8-34.85c-10.83 0-17.8 8.15-17.8 18.66s7 18.66 17.8 18.66 17.8-8.15 17.8-18.66-6.97-18.68-17.8-18.68zM316.54 92.77c-5.9 7.61-13 10.4-22.31 10.4-15.77 0-25.42-11.79-25.42-26.38 0-15.55 10.94-26.39 25.74-26.39 14.16 0 23.81 9.66 23.81 26.28v2.68h-40.54c.64 8.69 7.29 16.09 16.41 16.09 7.18 0 12-2.57 16-7.61zm-7.19-20.49c-.32-8.47-5.9-14.15-15.12-14.15s-15.34 5.68-16.41 14.15zM328.12 63.6c0-4.61-.43-8.58-.43-11.91h7.93c0 2.68.22 5.47.22 8.26h.21c2.26-4.93 8.48-9.55 16.74-9.55 10.83 0 14.26 6.12 15.87 9.55 3.65-5.9 8.26-9.55 15.87-9.55 14.37 0 19.09 8.05 19.09 21v30.46h-8.36v-30c0-7-2.47-13.73-12.23-13.73-7.08 0-13 5.79-13 14.8v29h-8.36V73.47c0-11-2.79-15.34-9.66-15.34-10.83 0-15.55 7.83-15.55 19.3v24.46h-8.36z"
})));
var SvgNavyLogo = function SvgNavyLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 403.62 104.93"
  }, props), _ref, _ref2);
};
export default SvgNavyLogo;